import { render } from "./ForgotHeaderBar.vue?vue&type=template&id=2584a1ba&ts=true"
import script from "./ForgotHeaderBar.vue?vue&type=script&lang=ts"
export * from "./ForgotHeaderBar.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__